import * as Init from '../init.js';
import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as FVERIFY from './fverify.res.js'

function getMclassName(inData) {
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    return inData['workers'][mclassindex]
}
function changeFactorInfo(inData, redraw) {
    const mclassname = getMclassName(inData)
    console.log(inData);
    
    FVERIFY.clearFactors()
    const factorchart = Init.getUserInfo(inData.modulename, mclassname + 'factorchart', 'WgroupChart')
    const factorvname = Init.getUserInfo(inData.modulename, mclassname + 'factorvname', 'WgroupChart1d')
    if (inData.modulename === 'single') {
        // wgroup_1d,wgroup_3d,wgroup_5d,wgroup_ad,degree_up,degree_dn,income_fu,income_sp
        for (let index = 0; index < inData['factors'].datas.length; index++) {
            let infos = []
            if (factorchart === 'WotherChart') {
                if (factorvname === 'WotherChartdn') {
                    const vv = CLAPI.getData(inData['assess'], 'degree_dn', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }
                else if (factorvname === 'WotherChartup') {
                    const vv = CLAPI.getData(inData['assess'], 'degree_up', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }
                else if (factorvname === 'WotherChartsp') {
                    const vv = CLAPI.getData(inData['assess'], 'income_sp', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                } 
                else {
                    const vv = CLAPI.getData(inData['assess'], 'income_fu', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }         
            }
            else {
                if (factorvname === 'WgroupChart1d') {
                    const vv = CLAPI.getData(inData['assess'], 'wgroup_1d', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }
                else if (factorvname === 'WgroupChart3d') {
                    const vv = CLAPI.getData(inData['assess'], 'wgroup_3d', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }
                else if (factorvname === 'WgroupChart5d') {
                    const vv = CLAPI.getData(inData['assess'], 'wgroup_5d', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                }
                else {
                    const vv = CLAPI.getData(inData['assess'], 'wgroup_ad', index)
                    infos.push(vv === 1 ? vv : -1 * vv)
                } 
            }
            
            FVERIFY.incrFactors(CLAPI.getData(inData['factors'], 'name', index), infos)
        }
    }
    else {

        for (let index = 0; index < inData['factors'].datas.length; index++) {
            let infos = []
            if (factorchart === 'WotherChart') {
                if (factorvname === 'WotherChartdn') {
                    infos.push(CLAPI.getData(inData['assess'], 'degree_dn_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'degree_dn_negi', index) % 10)
                }
                else if (factorvname === 'WotherChartup') {
                    infos.push(CLAPI.getData(inData['assess'], 'degree_up_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'degree_up_negi', index) % 10)
                }
                else if (factorvname === 'WotherChartsp') {
                    infos.push(CLAPI.getData(inData['assess'], 'income_sp_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'income_sp_negi', index) % 10)
                } 
                else {
                    infos.push(CLAPI.getData(inData['assess'], 'income_fu_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'income_fu_negi', index) % 10)
                }         
            }
            else {
                if (factorvname === 'WgroupChart1d') {
                    infos.push(CLAPI.getData(inData['assess'], 'wgroup_1d_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'wgroup_1d_negi', index) % 10)
                }
                else if (factorvname === 'WgroupChart3d') {
                    infos.push(CLAPI.getData(inData['assess'], 'wgroup_3d_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'wgroup_3d_negi', index) % 10)
                }
                else if (factorvname === 'WgroupChart5d') {
                    infos.push(CLAPI.getData(inData['assess'], 'wgroup_5d_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'wgroup_5d_negi', index) % 10)
                }
                else {
                    infos.push(CLAPI.getData(inData['assess'], 'wgroup_ad_posi', index) % 10)
                    infos.push(-1 * CLAPI.getData(inData['assess'], 'wgroup_ad_negi', index) % 10)
                } 
            }
            
            FVERIFY.incrFactors(CLAPI.getData(inData['factors'], 'name', index), infos)
        }
    }
    if (redraw) {
        const curChart = Init.getSysChart()
        const chart = curChart.getUserChart('factorCtrl', 'factorCtrl')
        chart.changeCtrls(FVERIFY.CHART_VERIFY_FACTORS.ctrls)
    }
}
function setFactorCtrl(curChart, inData, region) {
    const chartName = 'factorCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            offset: { // 图形的偏移位置（不包括标题等），margin为整个图形区，offset仅仅是图形
                left: 1,
                top: 1,
                right: 0,
                bottom: 1,
            },
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 4, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_FACTORS,
        rectMain: curRect

    }
    FVERIFY.setFactorsTitle('因子集(' + inData['factors'].datas.length + ')')
    
    const mclassname = getMclassName(inData)
    
    changeFactorInfo(inData, false)

    let factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
    curCfg.config.selectIndex = factorindex

    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            if (result.selectIndex < 0) {
                return factorindex
            }
            else if (result.selectIndex !== factorindex ) {
                Init.setUserInfo(inData.modulename, mclassname + 'factorindex', result.selectIndex)
                factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)
                onLoadData(inData, false)
            }
        }
    })
}
function setMclassCtrl(curChart, inData, region) {
    const chartName = 'mclassCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_MCLASS,
        rectMain: curRect

    }
    let mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
    curCfg.config.selectIndex = mclassindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            console.log(chartName, result)
           
            if (result.selectIndex < 0) {
                let styleindex = Init.getUserInfo(inData.modulename, 'styleindex', 0)
                Init.setUserInfo(inData.modulename, 'styleindex', (++styleindex % 2))
                onClassLoad(inData)
                return mclassindex
            }
            else if (result.selectIndex !== mclassindex ) {
                Init.setUserInfo(inData.modulename, 'mclassindex', result.selectIndex)
                mclassindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, 'mclassindex', 0), inData['workers'].length)
                onClassLoad(inData)
            }
        }
    })
}
function setMinuteCtrl(curChart, inData, region) {
    const chartName = 'minuteCtrl'
    const chart = curChart.getChart(chartName)

    const curRect = CLAPI.getChartRect(region)
    const curCfg = {
        layout: {
            title: {
                pixel: 12, // 字体大小
                height: 18, // 最大高度
                spaceX: 10, // X方向留空
                spaceY: 2, // Y方向留空
            }
        },
        config: FVERIFY.CHART_VERIFY_MINUTE,
        rectMain: curRect

    }
    const mclassname = getMclassName(inData)

    let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), inData['minutes'].length)
    
    curCfg.config.selectIndex = minuteindex;
    
    const curchart = chart.createChart(chartName, 'system.ctrls', curCfg, function (result) {
        // 这里应该返回交互信息 比如按钮按下 光标位置等
        if (result.event === 'btndown') {
            // console.log(chartName, result)
            Init.setUserInfo(inData.modulename, mclassname + 'minuteindex', result.selectIndex)
            onLoadData(inData, true)
        }
    })
}

function setWgroupChart(curChart, inData, region) {
    
    const chartName = 'WgroupChart'
    const chart = curChart.getChart(chartName)

    const groups = FVERIFY.amountGetGroups(inData['amount'])
    let lines = FVERIFY.getChartLines(groups);
    let showinfo = 'sorted'
    if (inData.modulename === 'single') {
        lines = FVERIFY.getChartVBars(groups);
        showinfo = 'none'
    }

    const mclassname =getMclassName(inData)

    function onExpand(cvname) {
        const factorchart = Init.getUserInfo(inData.modulename, mclassname + 'factorchart', chartName)
        const change = FVERIFY.changeFocus(chartName, cvname)
        console.log(factorchart, chartName);
        Init.setUserInfo(inData.modulename, mclassname + 'factorchart', chartName)
        Init.setUserInfo(inData.modulename, mclassname + 'factorvname', cvname)
        if (factorchart !== chartName) {
            drawFVerify_wgroup(inData, true)
            FVERIFY.setFocus()
        }
        else if (change) {
            changeFactorInfo(inData, true)
        }
    }
    {
        const cvname = chartName + '1d'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 0)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '隔日:',
                        showinfo
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // console.log('main', result)
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + '3d'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 1)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: ' 3日:',
                        showinfo
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // console.log('main', result)
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + '5d'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 2)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: ' 5日:',
                        showinfo
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // console.log('main', result)
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'ad'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 3)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '10日:',
                        showinfo
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_FOOT),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // console.log('main', result)
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
}

function setWotherChart(curChart, inData, region) {
    const chartName = 'WotherChart'
    const chart = curChart.getChart(chartName)

    const groups = FVERIFY.amountGetGroups(inData['amount'])
    let lines = FVERIFY.getChartLines(groups);
    let showinfo = 'sorted'
    if (inData.modulename === 'single') {
        lines = FVERIFY.getChartVBars(groups);
        showinfo = 'none'
    }

    const mclassname =getMclassName(inData)

    function onExpand(cvname) {
        const change = FVERIFY.changeFocus(chartName, cvname)
        const factorchart = Init.getUserInfo(inData.modulename, mclassname + 'factorchart', chartName)
        Init.setUserInfo(inData.modulename, mclassname + 'factorchart', chartName)
        Init.setUserInfo(inData.modulename, mclassname + 'factorvname', cvname)
        if (factorchart !== chartName) {
            drawFVerify_wother(inData, true)
            FVERIFY.setFocus()
        }
        else if (change) {
            changeFactorInfo(inData, true)
        }
    }
    {
        const cvname = chartName + 'up'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 0)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '上涨周期:',
                        showinfo,
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'dn'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 1)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '下跌周期:',
                        showinfo,
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'fu'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 2)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '极限盈亏:',
                        showinfo,
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_HEAD),
            rectMain: curRect
        }
        // console.log(groups, curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
    {
        const cvname = chartName + 'sp'
        const curRect = CLAPI.getChartRect(region, 1, 4, 0, 3)
        // 设置界面信息和绑定数据
        const curCfg = {
            config: CLAPI.Utils.mergeObjectOfDeep({
                    title: {
                        label: '盈亏速度:',
                        showinfo,
                    },
                    lines: lines,
                },
                FVERIFY.CHART_VERIFY_FOOT),
            rectMain: curRect
        }
        // console.log(curCfg);
        // 其他为辅助数据 实际运算时
        const curchart = chart.createChart(cvname, 'system.fixed', curCfg, function (result) {
            // 这里应该返回交互信息 比如按钮按下 光标位置等
            // console.log('main', result)
            if (result.name === 'expand') {
                onExpand(cvname)
            }
        })
        chart.bindData(curchart, cvname)
    }
}

function readyWgroupChart(curChart, inData) {
    const chartName = 'WgroupChart'
    const chart = curChart.getChart(chartName)
    
    const axisXinfo = DATAS.extractField(inData['amount'], 'date')
    chart.setAxisXinfo(axisXinfo)

    {
        const cvname = chartName + '1d'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'wgroup_1d')
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + '3d'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'wgroup_3d')
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + '5d'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'wgroup_5d')
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'ad'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'wgroup_ad')
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
}

function readyWotherChart(curChart, inData) {
    const chartName = 'WotherChart'
    const chart = curChart.getChart(chartName)

    const axisXinfo = DATAS.extractField(inData['amount'], 'date')
    chart.setAxisXinfo(axisXinfo)

    {
        const cvname = chartName + 'up'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'degree_up')
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'dn'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'degree_dn')
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'fu'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'income_fu')
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'sp'
        const vdatas = FVERIFY.amountToDatas(inData['amount'], 'income_sp')
        // console.log(JSON.stringify(vdatas));
        chart.setData(cvname, vdatas)
    }
}

function readyMgroupChart(curChart, inData) {
    const chartName = 'WgroupChart'
    const chart = curChart.getChart(chartName)
    
    chart.setAxisXinfo([0.2, 0.4, 0.6, 0.8, '1.0'])

    {
        const cvname = chartName + '1d'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'wgroup_1d', inData.amountname)
        console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + '3d'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'wgroup_3d', inData.amountname)
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + '5d'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'wgroup_5d', inData.amountname)
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'ad'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'wgroup_ad', inData.amountname)
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
}

function readyMotherChart(curChart, inData) {
    const chartName = 'WotherChart'
    const chart = curChart.getChart(chartName)

    chart.setAxisXinfo([0.2, 0.4, 0.6, 0.8, '1.0'])

    {
        const cvname = chartName + 'up'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'degree_up', inData.amountname)
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'dn'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'degree_dn', inData.amountname)
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'fu'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'income_fu', inData.amountname)
        // console.log(vdatas);
        chart.setData(cvname, vdatas)
    }
    {
        const cvname = chartName + 'sp'
        const vdatas = FVERIFY.amountToDatasSingle(inData['amount'], 'income_sp', inData.amountname)
        // console.log(JSON.stringify(vdatas));
        chart.setData(cvname, vdatas)
    }
}
function drawFVerify(inData, isFirst, wininfos) {

    console.log('Draw ====> FVerify Line')
    // console.log(JSON.stringify(inData));
    // console.log(inData);
    console.log(wininfos);

    const curChart = Init.getSysChart()

    if (isFirst) {
        // 设置为单一窗口 并返回第一个窗口
        curChart.initChart(['WgroupChart', 'WotherChart', 'mclassCtrl', 'minuteCtrl', 'factorCtrl'])

        const canvas = Init.canvas

        const head = wininfos.mclass.height
        
        // 设置顶部窗口
        setMclassCtrl(curChart, inData, {
            style: 'sidebar',
            top: 0,
            left: 0,
            width: wininfos.mclass.width,
            height: head,
        })

        const high = canvas.height - head
        // 设置左部窗口
        setFactorCtrl(curChart, inData, {
            style: 'sidebar',
            top: head,
            left: 0,
            width: wininfos.factors.width - Init.scale,
            height: high,
        })
        const minuteW = (canvas.width - wininfos.factors.width)
        // 设置分钟窗口
        setMinuteCtrl(curChart, inData, {
            style: 'sidebar',
            top: head,
            left: wininfos.factors.width,
            width: minuteW,
            height: head - Init.scale,
        })
        
        // 设置第一个窗口
        setWgroupChart(curChart, inData, {
            style: 'average',
            top: head + head,
            left: wininfos.factors.width,
            width: wininfos.wgroup.width,
            height: high - head,
        })
        setWotherChart(curChart, inData, {
            style: 'average',
            top: head + head,
            left: wininfos.factors.width + wininfos.wgroup.width,
            width: wininfos.wother.width,
            height: high - head,
        })
    }
    // console.log(inData['amount'].datas[803]);
    if (inData.modulename === 'single') {
        readyMgroupChart(curChart, inData)
        readyMotherChart(curChart, inData)
    }
    else {
        readyWgroupChart(curChart, inData)
        readyWotherChart(curChart, inData)
    }

    curChart.onPaint()
}

function drawFVerify_wgroup(inData, isFirst) {
    const canvas = Init.canvas
    const factorsWidth = FVERIFY.FWIDTH * Init.scale;
    const wgroupWidth = (canvas.width - factorsWidth) * 0.618;
    const wotherWidth = (canvas.width - factorsWidth - wgroupWidth);
    
    drawFVerify(inData, isFirst, {
        mclass : {
            height : 25 * Init.scale,
            width : canvas.width,
        },
        factors : {
            width : factorsWidth,
        },
        wgroup : {
            width : wgroupWidth,
        },
        wother : {
            width : wotherWidth,
        },    
    })
}
function drawFVerify_wother(inData, isFirst) {
    const canvas = Init.canvas
    const factorsWidth = FVERIFY.FWIDTH * Init.scale;
    const wotherWidth = (canvas.width - factorsWidth) * 0.618;
    const wgroupWidth = (canvas.width - factorsWidth - wotherWidth)
    
    drawFVerify(inData, isFirst, {
        mclass : {
            height : 25 * Init.scale,
            width : canvas.width,
        },
        factors : {
            width : factorsWidth,
        },
        wgroup : {
            width : wgroupWidth,
        },
        wother : {
            width : wotherWidth,
        },     
    })
}


function onLoadData(inData, isFirst) {
    const mclassname = getMclassName(inData)
    
    const factorchart = Init.getUserInfo(inData.modulename, mclassname + 'factorchart', 'WgroupChart')
    const factorvname = Init.getUserInfo(inData.modulename, mclassname + 'factorvname', 'WgroupChart1d')
    
    let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), inData['minutes'].length)
    
    let factorindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'factorindex', 0), inData['factors'].datas.length)

    const amountname = CLAPI.getData(inData['factors'], 'name', factorindex)
    
    const styleindex = Init.getUserInfo(inData.modulename, 'styleindex', 0)

    let amount = ".gw_amount"
    let assess = ".gw_assess"
    if (styleindex === 1) {
        amount = ".nw_amount"
        assess = ".nw_assess"
    }
    
    if (inData.modulename === 'single') {
        let curkey = Init.getcurKey()
        amount = ".gm_amount"
        assess = ".gm_assess"
        if (styleindex === 1) {
            amount = ".nm_amount"
            assess = ".nm_assess"
        }
        Init.sendCommand({
            cmds: {
                "amount": {
                    "cmd": "get",
                    "subject": curkey + amount,
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['minutes'][minuteindex],
                    "info": {
                        "offset": 0,
                    }
                },
                "assess": {
                    "cmd": "get",
                    "subject": curkey + assess,
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['minutes'][minuteindex],
                    "info": {
                        "offset": 0,
                    }
                }
            }
        },
        function reply(datas) {
            console.log(datas);
            
            if (Init.checkDatas(datas)) {
                inData['amount'] = datas['amount']
                inData['assess'] = datas['assess']
                inData.amountname = amountname
                if (factorchart === 'WotherChart') {
                    drawFVerify_wother(inData, isFirst)
                } 
                else { // 'WgroupChart'
                    drawFVerify_wgroup(inData, isFirst)
                }
                FVERIFY.changeFocus(factorchart, factorvname, true)
            }
        });
    }
    else {
        Init.sendCommand({
            cmds: {
                "amount": {
                    "cmd": "get",
                    "subject": amountname + amount,
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['minutes'][minuteindex],
                    "info": {
                        "offset": 0,
                    }
                },
                "assess": {
                    "cmd": "get",
                    "subject": "CN000000" + assess,
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + inData['minutes'][minuteindex],
                    "info": {
                        "offset": 0,
                    }
                }
            }
        },
        function reply(datas) {
            if (Init.checkDatas(datas)) {
                inData['amount'] = datas['amount']
                inData['assess'] = datas['assess']

                // console.log(inData['amount'].datas.at(-1))
                if (factorchart === 'WotherChart') {
                    drawFVerify_wother(inData, isFirst)
                } 
                // else if (factorchart === 'WgroupChart') {
                //     drawFVerify_wgroup(inData, isFirst)
                // }
                else { // 'WgroupChart'
                    drawFVerify_wgroup(inData, isFirst)
                }
                FVERIFY.changeFocus(factorchart, factorvname, true)
            }
        });
    }
}

export function onClassLoad(inData) {

    const mclassname = getMclassName(inData)
    let minutes = [] 
    function onInit() {
        let minuteindex = DATAS.getArrayIndex(Init.getUserInfo(inData.modulename, mclassname + 'minuteindex', 0), minutes.length)
        Init.sendCommand({
            cmds: {
                "factors": {
                    "cmd": "get",
                    "subject": "CN000000.factors",
                    "service": inData.modulepath + '/' + mclassname + "/verify/" + minutes[minuteindex],
                    "info": {
                        "offset": 0,
                    }
                }
            }
        },
        function reply(datas) {
            // console.log(datas)
            if (Init.checkDatas(datas)) {
                inData['minutes'] = minutes
                inData['factors'] = datas['factors']
                onLoadData(inData, true)
            }
        });
    }
    Init.sendCommand({
            cmds: {
                "minutes": {
                    "cmd": "files",
                    "service": inData.modulepath + '/' + mclassname + "/verify/*.mdb"
                }
            }
        },
        function reply(datas) {
            console.log(mclassname, datas)
            if (Init.checkDatas(datas)) {
                // 这里更新分钟数据
                datas['minutes'].datas.sort((a,b) => b[1].localeCompare(a[1]))
                for (let index = 0; index < datas['minutes'].datas.length; index++) {
                    let fname = datas['minutes'].datas[index][1];
                    minutes.unshift(fname.split('.').slice(0, -1).join('.'));
                }
                FVERIFY.onInit(inData['workers'], minutes)
                // console.log(minutes)
                onInit()
            }
            else {
                const mclassindex = Init.getUserInfo(inData.modulename, 'mclassindex', -1)
                Init.setUserInfo(inData.modulename, 'mclassindex', mclassindex + 1)
                console.log(mclassindex);
                
            }
        });
}

export function onLoad(argvs) {
    let inData = {}
    inData.modulename = argvs.modulename ?? 'verify'
    inData.modulepath = argvs.modulepath ?? 'factors'

    inData['workers'] = ['really', 'before', 'femny']
    if (inData.modulename === 'marked') {
        inData['workers'] = ['fadmix']
    }

    onClassLoad(inData)
    // Init.sendCommand({
    //         cmds: {
    //             "workers": {
    //                 "cmd": "paths",
    //                 "service": inData.modulepath + '/'
    //             }
    //         }
    //     },
    //     function reply(datas) {
    //         console.log(datas)
    //         if (Init.checkDatas(datas)) {
    //             // 这里更新分钟数据
    //             inData['workers'] = []
    //             for (let index = 0; index < datas['workers'].datas.length; index++) {
    //                 inData['workers'].push(CLAPI.getData(datas['workers'], 'pathname', index))
    //             }
    //             onClassLoad(inData)
    //         }
    //     });
}
// 注册方法到参数表